import {FC, useEffect, useState} from "react";
import {IconUser} from "../icons/icons";
import {useLoadAvatarUrl} from "./useLoadAvatarUrl";

type UserAvatarProps = {
    displayName?: string,
    email?: string,
    photoURL?: string,
}

export const UserAvatar = ({displayName, email, photoURL}: UserAvatarProps) => {
    const {avatarUrl, isLoading, isError} = useLoadAvatarUrl(email);
    const [userAvatar, setUserAvatar] =
        useState(<DumbUserAvatar displayName={displayName} email={email} photoURL={photoURL}/>)

    useEffect( () => {
        if (!isLoading && !isError && avatarUrl) {
            setUserAvatar(<DumbUserAvatar displayName={displayName} email={email} photoURL={avatarUrl}/>)
        }
    }, [avatarUrl])

    return userAvatar;
};

const DumbUserAvatar = ({photoURL, displayName, email}: UserAvatarProps) => {
    if (photoURL) {
        const user = displayName || email;
        const altText = `Profile image for ${user}`;
        return <img src={photoURL} className="rounded-full" alt={altText} data-testid={`user-avatar-${user}`}/>
    }
    return <DefaultUserAvatar/>
};

const DefaultUserAvatar: FC = () => {
    const bgColour = "bg-gray-100"
    return <div className="flex items-center justify-center" data-testid="default-avatar">
        <div className={`rounded-full w-full ${bgColour}`}>
            <IconUser className={`rounded-full bg-gray-100 scale-75 ${bgColour}`}/>
        </div>
    </div>
};
